import React from "react";

const featuredArticles = [
  {
    date: "25 May, 2024",
    tag: "News",
    text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book."
  },
  {
    date: "25 May, 2024",
    tag: "News",
    text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book."
  }
];

export default function FeaturedNewsNews() {
  return (
    <section className="w-full py-16 px-6 bg-transparent text-white">
      <div className="max-w-6xl mx-auto flex flex-col gap-6">
        {featuredArticles.map((art, idx) => (
          <div
            key={idx}
            className="w-full bg-[#E5E5E5] text-black rounded-xl p-6 md:p-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-6 hover:shadow-xl hover:shadow-secondary/5 transition-all duration-300 group"
          >
            {/* Left Content */}
            <div className="flex-1 flex flex-col items-start text-left">
              {/* Date & Tag */}
              <div className="flex items-center gap-4 mb-4">
                <span className="text-xs text-neutral-500 font-outfit font-light">
                  {art.date}
                </span>
                <span className="bg-black text-white text-[10px] uppercase font-bold tracking-wider px-2 py-0.5 rounded font-outfit">
                  {art.tag}
                </span>
              </div>

              {/* Text */}
              <p className="text-neutral-800 font-outfit text-sm md:text-base leading-relaxed pr-0 md:pr-10">
                {art.text}
              </p>
            </div>

            {/* Right Arrow Button */}
            <button className="w-12 h-12 rounded-full border border-neutral-300 bg-white hover:bg-secondary hover:border-secondary flex items-center justify-center text-neutral-800 hover:text-black transition-all duration-300 shadow-md group-hover:scale-105 active:scale-95 outline-none focus:outline-none flex-shrink-0">
              <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
              </svg>
            </button>
          </div>
        ))}

        {/* Load More Button */}
        <div className="flex justify-center mt-6">
          <button className="px-10 py-3.5 bg-secondary text-black font-bold font-outfit text-sm uppercase tracking-widest rounded-md hover:bg-white hover:text-black hover:shadow-lg hover:shadow-secondary/20 transition-all duration-300 active:scale-95 outline-none focus:outline-none">
            Load More
          </button>
        </div>
      </div>
    </section>
  );
}
